import moment from "moment";
export var serviceRequestConstent = {
    id: "",
    serviceRequestID: "",
    acCode: "",
    acName: "",
    clientTier: "",
    categoryId: 0,
    callTypeId: 0,
    subTypeId: 0,
    assignTeamCode: 0,
    assinIndividualCode: "",
    assinIndividualName: "",
    sourceCode: 0,
    refNumber: "",
    descriptions: "",
    action: "",
    operation: "",
    remark: "",
    reason: "",
    createdBy: "",
    statusId: 0,
    subStatusId: 0,
    mobileNo: "",
    emailId: "",
    subSourceId: 0,
    subSource: "",
    platformId: 0,
    platform: "",
    pan: "",
    dob: "",
    employeeName: "",
    createdUser: "",
    createdUserTeamCode: 0,
    createdUserTeamName: "",
    diS_DPID: "",
    diS_BOAccountNumber: "",
    diS_BOName: "",
    diS_SecondHolderName: "",
    diS_ThirdHolderName: "",
    diS_Address: "",
    diS_Mobile: "",
    diS_Email: "",
    diS_NoBookletsReq: "0",
    diS_TypeofRequest: "",
    diS_InwardDate: "",
    schemeChange_DPID: "",
    schemeChange_BONumber: "",
    schemeChange_BOName: "",
    schemeChange_SecondHolderName: "",
    schemeChange_ThirdHolderName: "",
    schemeChange_ExistingScheme: "",
    schemeChange_NewScheme: "",
    schemeChange_LOB: "",
    schemeChange_Mobile: "",
    schemeChange_Email: "",
    schemeChange_PAN: "",
    schemeChange_ModeOfRequest: "",
    schemeChange_Address: "",
    schemeChange_clientType: "",
    dPType: "",
    clientCategory: "",
    dnd: "",
    dndReasonId: "",
    dealerCode: "None",
    applicableFor: "None",
    categoryName: "Request",
    callTypeName: "Modification",
    subTypeName: "Income Declaration",
    assignTeamName: "OPS Helpdesk Team",
    status: "Open",
    assignType: "true",
    sourceName: "BRANCH",
    subStatus: "Approved",
    isPreFilled: "true",
    creator_sub_lob: "None",
    diS_LOB: "PWA",
    serviceRequestSecondary: {
        service_Request_id: 0,
        income_proof: "",
        secondary_request_data: {
            type: "",
            other_type: "",
            income_range: "",
            income_as_on_date: moment().format("YYYY-MM-DD"),
            net_worth_value: "",
            net_worth_as_on_date: "",
            gross_annual_income_range_code: "",
            fixed_assets: 0,
            investment: 0,
            cash_and_bank_balance: 0,
            current_assests: 0,
            annual_income_declared: 0,
            stock_in_hand: 0,
            others: 0,
            value_of_Assests: 0,
        },
    },
    arrFileName: [],
    arrbase64document: [],
};
export var ErrorText = [
    "Oops… this account is already added in",
    "Oops... this account is already mapped",
];
export var familyMembersDetails = [
    {
        id: "1432123322",
        name: "Sebastian Ceasre Eric",
        relationship: "Father",
        status: "Accepted",
        action: "",
        showPop: false,
        approvalReq: false,
    },
    {
        id: "1432123322",
        name: "Sebastian Ceasre Eric",
        relationship: "Father",
        status: "Accepted",
        action: "",
        showPop: false,
        approvalReq: false,
    },
    {
        id: "1432123322",
        name: "Sebastian Ceasre Eric",
        relationship: "Father",
        status: "Pending",
        action: "Resend Request",
        showPop: false,
        approvalReq: false,
    },
    // {
    //   id: "1432123322",
    //   name: "Sebastian Ceasre Eric",
    //   relationship: "Father",
    //   status: "Declined",
    //   action: "",
    //   showPop: false,
    //   approvalReq: false,
    // },
    // {
    //   id: "1432123322",
    //   name: "Sebastian Ceasre Eric",
    //   relationship: "Father",
    //   status: "Declined",
    //   action: "",
    //   showPop: false,
    //   approvalReq: false,
    // },
];
export var selfFamilycolumnHeader = [
    { title: "Family Name", eventKey: "family_name" },
    { title: "Family ID", eventKey: "family_id" },
    { title: "No. of Members", eventKey: "no_of_members" },
    { title: "Action", eventKey: "action" },
];
